// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-section{padding:20vw 0;min-height:50vh}.error-section a{border:1px solid #1c0f0c;padding:1rem 2rem .8rem;transition:all .2s cubic-bezier(.455,.03,.515,.955);display:inline-block}@media (min-width:768px){.error-section a{margin-top:1rem}}.error-section a:hover{text-decoration:none;background:#1c0f0c;color:#fff}", ""]);
// Exports
module.exports = exports;
